import React from "react";

const TestimonialSection = () => {
  return (
    /* Testimonial (bg-base-dark) start */
    <section className="prt-row bg-img2 prt-bgimage-yes prt-bg bg-base-dark testimonial-section z-index-0 clearfix">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-3 col-lg-12">
            <div className="prt_single_image-wrapper testimonial ml_100">
              <img
                width="413"
                height="413"
                src="/assets/images/equipomag-logo.png"
                loading="lazy"
                alt="testimonial-1"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-xl-9 col-lg-12 res-1199-mt-30">
            <div
              className="row slick_slider slick-arrow-style1"
              data-slick='{
                "slidesToShow": 1, 
                "slidesToScroll": 1, 
                "arrows": true, 
                "dots": false, 
                "autoplay": false, 
                "infinite": true,
                "responsive": [
                  {"breakpoint":1340,"settings":{"slidesToShow":1,"arrows":false,"autoplay":true}},
                  {"breakpoint":778,"settings":{"slidesToShow":1,"arrows":false}},
                  {"breakpoint":611,"settings":{"slidesToShow":1}}
                ]
              }'
            >
              {/* Testimonial 1 */}
              <div className="col-lg-12">
                <div className="testimonial">
                  <div className="testimonial-content">
                    <div className="testimonial-info border-right border-opacity">
                      <div className="testimonial-avatar">
                        <img
                          width="171"
                          height="171"
                          src="/assets/images/testimonial/fernando.webp"
                          loading="lazy"
                          alt="testimonial-1"
                          className="img-fluid"
                        />
                      </div>
                      <div className="testimonial-caption">
                        <h3 className="caption-heading">Fernando.</h3>
                        <div className="caption-text"></div>
                      </div>
                    </div>
                    <div className="testimonial-text">
                      <blockquote className="testimonial-blockquote">
                        Tenía sobrepeso, grado obesidad extrema. Corría riesgo mi vida.
                        Desde la primera semana que inicie el proceso; mi forma comer, hacer deporte, andar... me cambio la vida.
                        En 6 meses he perdído 31 kilos.
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
              {/* Testimonial 2 */}
              <div className="col-lg-12">
                <div className="testimonial">
                  <div className="testimonial-content">
                    <div className="testimonial-info border-right border-opacity">
                      <div className="testimonial-avatar">
                        <img
                          width="171"
                          height="171"
                          src="/assets/images/testimonial/monica.webp"
                          loading="lazy"
                          alt="testimonial-2"
                          className="img-fluid"
                        />
                      </div>
                      <div className="testimonial-caption">
                        <h3 className="caption-heading">Mónica</h3>
                        <div className="caption-text">Consulta de Villaverde del Río</div>
                      </div>
                    </div>
                    <div className="testimonial-text">
                      <blockquote className="testimonial-blockquote">
                        Mi experiencia con Equipo MAG es bastante buena.
                        Javi lleva mi asesoramiento, es un encanto, muy paciente y cercano.
                        En general estoy muy contenta con el equipo y siempre que puedo lo recomiendo sin dudarlo.
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
              {/* Testimonial 2 */}
              <div className="col-lg-12">
                <div className="testimonial">
                  <div className="testimonial-content">
                    <div className="testimonial-info border-right border-opacity">
                      <div className="testimonial-avatar">
                        <img
                          width="171"
                          height="171"
                          src="/assets/images/testimonial/elizabeth.webp"
                          loading="lazy"
                          alt="testimonial-2"
                          className="img-fluid"
                        />
                      </div>
                      <div className="testimonial-caption">
                        <h3 className="caption-heading">Elizabeth Cobos</h3>
                        <div className="caption-text"></div>
                      </div>
                    </div>
                    <div className="testimonial-text">
                      <blockquote className="testimonial-blockquote">
                        Para mí estar en manos del equipo es volver a la vida. Lo mejor,
                        conoceros y seguir vuestra disciplina alimentaria, que me ha hecho
                        volver a confiar en mí y conseguir un estado de salud asombroso y los 70kg perdidos en un año

                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
              {/* Testimonial 2 */}
              <div className="col-lg-12">
                <div className="testimonial">
                  <div className="testimonial-content">
                    <div className="testimonial-info border-right border-opacity">
                      <div className="testimonial-avatar">
                        <img
                          width="171"
                          height="171"
                          src="/assets/images/testimonial/mercedes.webp"
                          loading="lazy"
                          alt="testimonial-2"
                          className="img-fluid"
                        />
                      </div>
                      <div className="testimonial-caption">
                        <h3 className="caption-heading">Mercedes</h3>
                        <div className="caption-text"></div>
                      </div>
                    </div>
                    <div className="testimonial-text">
                      <blockquote className="testimonial-blockquote">
                        Me pusiste en el camino correcto, solo me hizo falta seguirlo.
                        Tenía un problema con mi azúcar y ahora está de diez!. Tomaba tres pastillas
                        y ahora sólo una. A seguir con muchas ganas!
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
              {/* Add more testimonials as needed */}
            </div>
          </div>
        </div>
      </div>
    </section>
    /* Testimonial (bg-base-dark) end */
  );
};

export default TestimonialSection;
